import React from 'react';

import SvgIcon from '../SvgIcon/SvgIcon';

function MagnifyingGlassIcon(props) {
    return (
        <SvgIcon stroke="currentColor" strokeWidth={1.5} style={{ fill: 'none' }} {...props} >
            <path d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" strokeLinecap="round" strokeLinejoin="round" />
        </SvgIcon>
    );
}

export default MagnifyingGlassIcon;
